import { FC, useMemo, useState } from "react"

import ReservationCartArticle from "models/ReservationCartArticle"
import InvoicePositionTextModal from "components/InvoicePositionTextModal/InvoicePositionTextModal"
import ReservationArticle from "models/ReservationArticle"
import { InsertConfigurationModal } from "components/InvoicePositionTextModal/InsertConfigurationModal"
import { TextVariableGroup } from "config/constants"
import useConfigurationText from "hooks/useConfigurationText"
import { IArticleSelectionValue } from "components/ArticleSelection/useArticleSelection"
import ReservationCartAsset from "models/ReservationCartAsset"
import ReservationAsset from "models/ReservationAsset"

interface IReservationInvoicePositionTextModalProps {
    text?: string
    articles?: ReservationCartArticle[] | ReservationArticle[]
    reservationLanguage?: string
    onSave?(text: string): Promise<void> | void
    onClose(): void
}

const ReservationInvoicePositionTextModal: FC<IReservationInvoicePositionTextModalProps> = ({
    text: initialText,
    articles,
    reservationLanguage,
    onSave,
    onClose,
}) => {
    const [text, setText] = useState(initialText || "")
    const { getConfigurationText } = useConfigurationText()
    const [showInsertConfigurationModal, setShowInsertConfigurationModal] = useState(false)

    const configurationData = useMemo(() => {
        return articles?.map((item) => ({
            articleId: item.articleId,
            articleNumber: item.articleNo,
            articleDescription: item.articleDescription,
            assetsCount: item.assets.length
        })) ?? []
    }, [articles])

    function onInsertConfiguration({ selectedArticles, mergeAssets, printFeatures }: IArticleSelectionValue) {
        if (!articles) return

        setText(getConfigurationText({
            selectedArticles,
            mergeAssets,
            printFeatures,
            language: reservationLanguage,
            articles: articles.map((article: ReservationCartArticle | ReservationArticle) => ({
                articleId: article.articleId,
                articleDescriptionTranslations: article.articleDescriptionTranslations ?? {},
                articleFeatures: article.articleFeatures,
                assets: article.assets.map((asset: ReservationCartAsset | ReservationAsset) => ({
                    assetId: asset.assetId,
                    isFixed: asset.isFixed,
                    lmid: asset.lmid,
                    serialNumber: asset.serialNumber,
                    assetFeatures: asset.features
                }))
            }))
        }))
    }

    return (
        <>
            <InvoicePositionTextModal
                isAdd={!initialText}
                text={text}
                setText={setText}
                onInsertConfiguration={articles ? () => setShowInsertConfigurationModal(true) : undefined}
                onSave={onSave}
                onClose={onClose}
                textVariableGroup={TextVariableGroup.withInvoiceCounterRequest}
            />

            {showInsertConfigurationModal &&
                <InsertConfigurationModal
                    articles={configurationData}
                    onClose={() => { setShowInsertConfigurationModal(false) }}
                    onSave={onInsertConfiguration}
                />
            }
        </>
    )
}

export default ReservationInvoicePositionTextModal
